import { render } from "./ConsentsPage.vue?vue&type=template&id=5141b21c&ts=true"
import script from "./ConsentsPage.vue?vue&type=script&lang=ts"
export * from "./ConsentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Consent/ConsentsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5141b21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5141b21c', __exports__)) {
    api.reload('5141b21c', __exports__)
  }
  
  module.hot.accept("./ConsentsPage.vue?vue&type=template&id=5141b21c&ts=true", () => {
    api.rerender('5141b21c', render)
  })

}


export default __exports__